<template>
  <slot />
</template>

<script setup lang="ts">
import { serializeJsonLd } from "@/shared/utils/jsonLdSerialize";

interface JsonLDOptions {
  type?: string;
  headline?: string;
  datePublished?: string;
  dateModified?: string;
  image?: string;
  author?: string;
  url?: string;
  mainEntityOfPage?: string;
  publisherName?: string;
  publisherLogo?: string;
}

const props = defineProps<{ jsonOptions: JsonLDOptions }>();

useHead(() => {
  const json: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": props.jsonOptions.type ?? "",
    headline: props.jsonOptions.headline ?? "",
    datePublished: props.jsonOptions.datePublished ?? "",
    dateModified: props.jsonOptions.dateModified ?? "",
    image: props.jsonOptions.image ?? "",
    author: [
      {
        "@type": "Organization",
        name: props.jsonOptions.author ?? "",
        url: props.jsonOptions.url ?? "",
      },
    ],
  };

  if (props.jsonOptions.mainEntityOfPage) {
    json.mainEntityOfPage = {
      "@type": "WebPage",
      "@id": props.jsonOptions.mainEntityOfPage,
    };
  }

  if (props.jsonOptions.publisherName) {
    json.publisher = {
      "@type": "Organization",
      name: props.jsonOptions.publisherName,
      logo: {
        "@type": "ImageObject",
        url: props.jsonOptions.publisherLogo ?? "",
      },
    };
  }

  return {
    script: [
      {
        type: "application/ld+json",
        innerHTML: serializeJsonLd(json),
      },
    ],
  };
});
</script>

<style scoped></style>
